import {
  BaSeButton,
  BaSeContainer,
  BaSeDialogContext,
  BaSeInput,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTabs,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import {
  ContainerTabs,
  HeaderContainer,
  HeaderContent,
} from './avaliar-questionario-style';
import FormQuestionConfirm from './form-question-confirm';
import { AlignRow } from './form-question-confirm-style';
import ModalConfirm from './modal-confirm';
const mapTitleModal = {
  APROVADO: `Aprovar candidato`,
  REPROVADO: `Reprovar candidato`,
};

function AvaliarQuestionario({
  setShowAvaliableCandidate,
  respostasQuestionarioStartup,
  hasApprove,
  setHasApprove,
}) {
  const [onTabIndex, setOnTabIndex] = React.useState(0);
  const { idInterview } = respostasQuestionarioStartup;
  const { showModal } = React.useContext(BaSeDialogContext);

  const openDialogConfirm = React.useCallback(
    (option) => {
      return showModal({
        actions: [],
        size: 'small',
        title: mapTitleModal[option],
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <ModalConfirm
            option={option}
            emitEvent={emitEvent}
            closeModal={closeModal}
            setShowAvaliableCandidate={setShowAvaliableCandidate}
            idInterview={idInterview}
          />
        ),
        onChooseAction: (action) => {},
      });
    },
    [showModal, setShowAvaliableCandidate, idInterview],
  );

  const avaliar = React.useCallback(
    (st) => {
      openDialogConfirm(st);
    },
    [openDialogConfirm],
  );

  const tabs = React.useMemo(
    () => [
      {
        title: 'Dados básicos',
        content: () => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 12,
              paddingTop: 12,
              width: '50%',
            }}
          >
            <BaSeInput
              isReadOnly
              label="E-mail:"
              value={respostasQuestionarioStartup?.basicData?.email}
            />
            <AlignRow>
              <BaSeInput
                isReadOnly
                label="UF do seminário:"
                value={respostasQuestionarioStartup?.basicData?.uf}
              />
              <BaSeInput
                isReadOnly
                label="Cidade:"
                value={respostasQuestionarioStartup?.basicData?.city}
              />
            </AlignRow>

            <AlignRow>
              <BaSeInput
                isReadOnly
                label="Data de nascimento:"
                value={respostasQuestionarioStartup?.basicData?.birthDate}
              />
              <BaSeInput
                isReadOnly
                label="Telefone:"
                value={respostasQuestionarioStartup?.basicData?.phone}
                typeInput="tel"
                inputMode="tel"
                mask="phoneDDD"
              />
            </AlignRow>

            <div>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae45}
              >
                Por que você decidiu fazer o Empretec Startup?
              </BaSeParagraph>
              <BaSeSmall1>
                {respostasQuestionarioStartup?.basicData?.situation}
              </BaSeSmall1>
            </div>
          </div>
        ),
      },
      {
        title: 'Questionário de seleção',
        content: () => (
          <FormQuestionConfirm
            respostasQuestionarioStartup={respostasQuestionarioStartup}
            avaliar={avaliar}
            hasApprove={hasApprove}
          />
        ),
      },
    ],
    [respostasQuestionarioStartup, avaliar, hasApprove],
  );

  return (
    <BaSeContainer
      style={{
        height: ` 100vh`,
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          boxShadow: `0px 4px 8px rgba(20, 46, 82, 0.2)`,
          borderRadius: '4px',
        }}
      >
        <BaSeButton
          leftIcon="arrow-circle-left-tonescale"
          type="tertiary"
          value="Voltar"
          onClick={() => {
            setShowAvaliableCandidate((prev) => !prev);
            setHasApprove(false);
          }}
        />

        <HeaderContainer>
          <HeaderContent>
            <BaSeParagraph isBold>
              {hasApprove ? 'Avaliar' : 'Visualizar'} questionário de seleção
            </BaSeParagraph>
            <BaSeParagraph
              isBold
            >{`${respostasQuestionarioStartup.name} - ${respostasQuestionarioStartup.cpf}`}</BaSeParagraph>
          </HeaderContent>
        </HeaderContainer>
        <ContainerTabs>
          <BaSeTabs
            activatedTabIndex={onTabIndex}
            onActivatedTabIndex={setOnTabIndex}
            tabs={tabs}
          />
        </ContainerTabs>
      </div>
    </BaSeContainer>
  );
}

export default AvaliarQuestionario;
